/**
 * Resolucion de configuracion runtime vs build-time:
 *   1) `window.__API_URL__` — inyectado por env.js (docker entrypoint) en runtime.
 *   2) `import.meta.env.VITE_API_BASE_URL` — definida en build (CI / local).
 *   3) Fallback: `/api` (mismo origen detras del proxy).
 */
function resolveApiBase(): string {
  const runtime = typeof window !== "undefined" ? (window as any).__API_URL__ : "";
  const buildTime = import.meta.env.VITE_API_BASE_URL || "";
  const raw = String(runtime || buildTime || "").trim().replace(/\/$/, "");
  if (!raw) return "/api";
  if (/\/api\/?$/.test(raw)) return raw;
  return `${raw}/api`;
}

function resolveAppPublicUrl(): string {
  const runtime = typeof window !== "undefined" ? (window as any).__APP_PUBLIC_URL__ : "";
  const buildTime = import.meta.env.VITE_APP_PUBLIC_URL || "";
  const raw = String(runtime || buildTime || "").trim().replace(/\/$/, "");
  return raw || "https://redipos.app";
}

export const API_BASE = resolveApiBase();

/** URL pública del panel de negocio (para impersonación / links). */
export const APP_PUBLIC_URL = resolveAppPublicUrl();
